<template>
  <div class="main-tab-strip">
    <div class="tabList"
         ref="tabListWrap"
         @contextmenu="onTabStripContextMenu">
      <el-tabs v-model="activeTab"
               type="card"
               class="tab_item"
               @tab-click="selectTab"
               @tab-remove="removeTab">
        <el-tab-pane v-for="item in TabList"
                     :key="item.name"
                     :label="item.title"
                     :name="item.name"
                     :closable="item.name !== '首页'">
        </el-tab-pane>
      </el-tabs>
    </div>
    <ul v-show="tabContextVisible"
        class="tab-context-menu"
        :style="tabContextStyle"
        @click.stop>
      <li v-if="contextTabName && contextTabName !== '首页'"
          class="tab-context-menu__item"
          @click="closeTabFromContext">关闭当前标签</li>
      <li class="tab-context-menu__item"
          @click="closeOtherTabsFromContext">关闭其它标签</li>
      <li class="tab-context-menu__item"
          @click="closeAllTabsFromContext">关闭全部标签</li>
    </ul>
  </div>
</template>

<script>
import { removeTab } from '@/utils/removeTab'

export default {
  name: 'MainTabStrip',
  computed: {
    activeTab: {
      get () { return this.$store.state.tabs.activeTab },
      set (val) { this.$store.commit('updateActiveTab', val) }
    },
    TabList: {
      get () { return this.$store.state.tabs.TabList },
      set (val) { this.$store.commit('updateTabList', val) }
    },
    tabContextStyle () {
      return {
        position: 'fixed',
        left: this.tabContextX + 'px',
        top: this.tabContextY + 'px',
        zIndex: 3000
      }
    }
  },
  data () {
    return {
      tabContextVisible: false,
      tabContextX: 0,
      tabContextY: 0,
      contextTabName: ''
    }
  },
  mounted () {
    this._hideTabContextOnDoc = (e) => {
      if (!this.tabContextVisible) return
      if (e.target && e.target.closest && e.target.closest('.tab-context-menu')) return
      this.tabContextVisible = false
    }
    this._hideTabContextOnScroll = () => {
      if (this.tabContextVisible) this.tabContextVisible = false
    }
    document.addEventListener('click', this._hideTabContextOnDoc, false)
    window.addEventListener('scroll', this._hideTabContextOnScroll, true)
  },
  beforeDestroy () {
    if (this._hideTabContextOnDoc) {
      document.removeEventListener('click', this._hideTabContextOnDoc, false)
    }
    if (this._hideTabContextOnScroll) {
      window.removeEventListener('scroll', this._hideTabContextOnScroll, true)
    }
  },
  methods: {
    selectTab (tab) {
      const name = tab.name
      localStorage.menuNameActive = name
      localStorage.logMenuName = name
      this.$store.commit('updateActiveTab', name)
      let path = ''
      try {
        path = this.$router.resolve({ name }).route.path || ''
      } catch (e) {
        path = ''
      }
      if (path.indexOf('Report/ReportsViewList') !== -1) {
        this.$router.push({ name, query: { t: Date.now() } })
      } else {
        this.$router.push({ name })
      }
    },
    removeTab (tabName) {
      removeTab(tabName, this)
    },
    getTabNameFromElItem (el) {
      if (!el) return null
      const id = el.id || ''
      if (id.indexOf('tab-') === 0) return id.slice(4)
      const ac = el.getAttribute && el.getAttribute('aria-controls')
      if (ac && ac.indexOf('pane-') === 0) return ac.slice(5)
      return null
    },
    onTabStripContextMenu (e) {
      const wrap = this.$refs.tabListWrap
      if (!wrap) return
      const item = e.target.closest && e.target.closest('.el-tabs__item')
      if (!item || !wrap.contains(item)) return
      e.preventDefault()
      const tabName = this.getTabNameFromElItem(item)
      if (!tabName) return
      this.contextTabName = tabName
      let x = e.clientX
      let y = e.clientY
      const menuW = 168
      const menuH = 132
      if (x + menuW > window.innerWidth) x = window.innerWidth - menuW - 8
      if (y + menuH > window.innerHeight) y = window.innerHeight - menuH - 8
      if (x < 4) x = 4
      if (y < 4) y = 4
      this.tabContextX = x
      this.tabContextY = y
      this.tabContextVisible = true
    },
    hideTabContextMenu () {
      this.tabContextVisible = false
      this.contextTabName = ''
    },
    closeTabFromContext () {
      const name = this.contextTabName
      this.hideTabContextMenu()
      if (!name || name === '首页') return
      this.removeTab(name)
    },
    closeOtherTabsFromContext () {
      const tabName = this.contextTabName
      if (!tabName) return
      this.hideTabContextMenu()
      this.TabList = this.TabList.filter(item => item.name === tabName || item.name === '首页')
      this.activeTab = tabName
      this.$store.commit('updateActiveTab', tabName)
      localStorage.logMenuName = tabName
      localStorage.menuNameActive = tabName
      if (this.$route.name !== tabName) {
        if (this.$route.path.indexOf('Report/ReportsViewList') !== -1) {
          this.$router.push({ name: tabName, query: { t: Date.now() } }).catch(() => {})
        } else {
          this.$router.push({ name: tabName }).catch(() => {})
        }
      }
    },
    closeAllTabsFromContext () {
      this.hideTabContextMenu()
      this.tabsCloseAllHandle()
    },
    tabsCloseAllHandle () {
      this.TabList = this.TabList.filter(item => item.name === '首页')
      this.activeTab = '首页'
      this.$store.commit('updateActiveTab', '首页')
      this.$router.push('/index')
      localStorage.logMenuName = ''
    }
  }
}
</script>

<style lang="stylus" scoped>
/* 标签行：深色商务风，减少高饱和高发光 */
$tab-text = #cbd5e1
$tab-muted = #94a3b8
$tab-border = rgba(148, 163, 184, 0.24)
$tab-bg = rgba(15, 23, 42, 0.72)
$tab-hover-bg = rgba(30, 41, 59, 0.85)

.main-tab-strip
  width 100%
  min-width 0
  display flex
  align-items center
  box-sizing border-box
  font-family 'Outfit', system-ui, -apple-system, 'Segoe UI', sans-serif
  -webkit-font-smoothing antialiased

.main-tab-strip>>>.el-tabs
  width 100%

.main-tab-strip>>>.el-tabs__content
  display none

.main-tab-strip>>>.el-tabs--card>.el-tabs__header .el-tabs__nav
  border none
  padding 3px 2px
  background transparent

.main-tab-strip>>>.el-tabs--card>.el-tabs__header .el-tabs__item
  border 1px solid $tab-border
  border-radius 22px
  margin 0 6px
  height 32px
  line-height 30px
  background $tab-bg
  color $tab-text
  transition background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.18s ease
  position relative !important
  overflow hidden
  font-weight 500
  letter-spacing 0.01em
  padding 0 30px 0 14px !important
  min-width auto
  flex-shrink 0
  white-space nowrap
  box-sizing border-box
  box-shadow 0 1px 2px rgba(2, 6, 23, 0.3)

.main-tab-strip>>>.el-tabs--card>.el-tabs__header .el-tabs__item.is-closable
  padding 0 30px 0 14px !important

.main-tab-strip>>>.el-tabs--card>.el-tabs__header .el-tabs__nav-wrap
  display flex
  flex-wrap nowrap
  overflow-x auto

.main-tab-strip>>>.el-tabs--card>.el-tabs__header .el-tabs__nav-scroll
  width 100%

.main-tab-strip>>>.el-tabs--card>.el-tabs__header .el-tabs__nav
  display flex
  flex-wrap nowrap
  align-items center

.main-tab-strip>>>.el-tabs--card>.el-tabs__header .el-tabs__item:first-child
  margin-left 0

.main-tab-strip>>>.el-tabs--card>.el-tabs__header .el-tabs__item:last-child
  margin-right 0

.main-tab-strip>>>.el-tabs--card>.el-tabs__header .el-tabs__item:hover
  background $tab-hover-bg !important
  color #e2e8f0 !important
  border-color rgba(148, 163, 184, 0.36) !important
  box-shadow 0 3px 12px rgba(2, 6, 23, 0.4)
  transform translateY(-1px)

.main-tab-strip>>>.el-tabs--card>.el-tabs__header .el-tabs__item.is-active
  background linear-gradient(145deg, #1e3a5f 0%, #1d3557 55%, #244064 100%)
  color #f8fafc
  border-color #60a5fa
  box-shadow 0 4px 12px rgba(15, 23, 42, 0.45), inset 0 1px 0 rgba(191, 219, 254, 0.16)
  transform translateY(-1px)

.main-tab-strip>>>.el-tabs--card>.el-tabs__header .el-tabs__item .el-icon-close
  border-radius 50%
  width 16px
  height 16px
  line-height 16px
  text-align center
  background rgba(148, 163, 184, 0.16)
  color $tab-muted
  transition all 0.2s ease
  font-size 12px
  position absolute !important
  right 10px !important
  top 50% !important
  transform translateY(-50%) !important
  font-weight bold

.main-tab-strip>>>.el-tabs--card>.el-tabs__header .el-tabs__item .el-icon-close:hover
  background #ff4d4f
  color #fff
  transform translateY(-50%) scale(1.08)
  box-shadow 0 2px 8px rgba(255, 77, 79, 0.35)

.main-tab-strip>>>.el-tabs--card>.el-tabs__header .el-tabs__item.is-active .el-icon-close
  background rgba(148, 163, 184, 0.22)
  color #fff

.main-tab-strip>>>.el-tabs--card>.el-tabs__header .el-tabs__item.is-active .el-icon-close:hover
  background #fff
  color #ef4444

.main-tab-strip>>>.el-tabs--card>.el-tabs__header
  border none
  margin-bottom 0
  padding 0 2px

.main-tab-strip>>>.el-tabs__nav-wrap::after
  height 0
  background transparent

.main-tab-strip>>>.el-tabs--card>.el-tabs__header .el-tabs__nav-wrap::-webkit-scrollbar
  height 5px

.main-tab-strip>>>.el-tabs--card>.el-tabs__header .el-tabs__nav-wrap::-webkit-scrollbar-track
  background rgba(15, 23, 42, 0.8)
  border-radius 3px

.main-tab-strip>>>.el-tabs--card>.el-tabs__header .el-tabs__nav-wrap::-webkit-scrollbar-thumb
  background rgba(148, 163, 184, 0.5)
  border-radius 3px

.main-tab-strip>>>.el-tabs--card>.el-tabs__header .el-tabs__nav-wrap::-webkit-scrollbar-thumb:hover
  background rgba(148, 163, 184, 0.72)

.tabList
  width 100%
  min-width 0

.tab-context-menu
  margin 0
  padding 6px 0
  list-style none
  min-width 140px
  background #0f172a
  border 1px solid rgba(148, 163, 184, 0.24)
  border-radius 8px
  box-shadow 0 10px 30px rgba(2, 6, 23, 0.45), 0 4px 12px rgba(15, 23, 42, 0.18)
  font-size 13px
  color #cbd5e1

.tab-context-menu__item
  padding 8px 16px
  cursor pointer
  line-height 1.4
  transition background 0.15s ease, color 0.15s ease
  &:hover
    background rgba(51, 65, 85, 0.8)
    color #dbeafe

.tab_item
  color $tab-text
</style>



// WEBPACK FOOTER //
// src/components/MainTabStrip.vue